import api from './api';

const quotationConfigService = {
    getConfig: async () => {
        const response = await api.get('/cotizaciones/configuracion/');
        return response.data;
    },

    updateConfig: async (data) => {
        const response = await api.put('/cotizaciones/configuracion/', data);
        return response.data;
    },

    getPreview: async (configOverride) => {
        const response = await api.post('/cotizaciones/configuracion/previsualizar/', configOverride, {
            responseType: 'blob'
        });
        return response.data;
    }
};

export default quotationConfigService;
